import DomComponent from '../../lib/domComponent';
import { getTrackingData, pushTrackingData } from '../../lib/dataLayer';

export default class TrackingEventsComponent extends DomComponent {
    static selector = '[data-tracking-event="link"],[data-tracking-event="action"]';

    constructor(el) {
        super(el);

        if(!this.el) {
            return;
        }

        this.init();
    }

    init() {
        const data = getTrackingData(this.el);

        this.el.addEventListener('click', () => {
            pushTrackingData(data);
        });
    }
}
